module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-2-1833e378ee121f159d01e7eec4c7d3a1.png";